import L from 'leaflet';
import * as ACTION from './actions';

import allPaths from './../../json/minify.json';
import geoUtil from 'leaflet-geometryutil';

const common = {
  currPath: undefined,
  pathToPath: undefined,
  currentPos: {
    lat: null,
    lng: null,
  },
  currentPosClosest: {
    lat: null,
    lng: null,
  },
};

const oliwaCemetery = {
  name: 'oliwa',
  color: '#795a22',
  entry: [54.41272472555069, 18.55964418500662],
  currentPos: {
    lat: 54.413671834360336,
    lng: 18.55081113019763,
  },
  ...common,
};

const srebrzyskoCemetery = {
  name: 'srebrzysko',
  color: '#72506e',
  entry: [54.376013879584093, 18.581158212207413],
  currentPos: {
    lat: 54.41155,
    lng: 18.55625,
  },
  ...common,
};

const lostowiceCemetery = {
  name: 'lostowice',
  color: '#c06453',
  entry: [54.340911219708644, 18.601013249265378],
  currentPos: {
    lat: 54.3397221217756,
    lng: 18.586549758911133,
  },
  ...common,
};

const INIT_STATE = {
  ...srebrzyskoCemetery,
  currentPos: {
    lat: 54.41155, // 54.3723,
    lng: 18.55625, //18.5825,
  },
  currentPosClosest: {
    lat: 54.376013879584093,
    lng: 18.581158212207413,
  },
  paths: allPaths,
  currentPosInBounds: false,
  loading: true,
  error: false,
  opened: false,
  data: null,
  shared: undefined,
  sharedHash: undefined,
  sharedGraves: [],
  currPath: undefined,
  pathToPath: undefined,
  selectedGrave: undefined,
  graves: [],
};

function data(state = INIT_STATE, action) {
  switch (action.type) {
    case ACTION.UPDATE_CURRENT_POSITION_INBOUNDS:
      return Object.assign({}, state, {
        currentPosInBounds: action.inBounds,
      });

    case ACTION.UPDATE_ClOSEST_POSITION:
      return Object.assign({}, state, {
        currentPosClosest: action.position,
      });

    case ACTION.UPDATE_CURRENT_POSITION:
      return Object.assign({}, state, {
        currentPos: action.position,
      });

    case ACTION.FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
      });

    case ACTION.FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        error: false,
        data: action.payload,
      });

    case ACTION.FETCH_FAIL:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload,
      });

    case ACTION.CONVERT_GRAVES:
      return {
        ...state,
        graves: state.data.graves.map((grave) => {
          grave.geometry.coordinates.reverse();
          grave.geometry.closest = geoUtil.closestLayerSnap(
            action.map,
            action.layers,
            new L.LatLng(
              grave.geometry.coordinates[0],
              grave.geometry.coordinates[1]
            )
          );
          grave.geometry.closestLL = [
            grave.geometry.closest.latlng.lng,
            grave.geometry.closest.latlng.lat,
          ];
          return grave;
        }),
      };

    case ACTION.ALERT_OPEN:
      return Object.assign({}, state, {
        opened: action.opened,
      });

    case ACTION.SHARE_PATH:
      return Object.assign({}, state, {
        hash: action.hash,
        graves: action.graves,
      });

    case ACTION.FETCH_SHARED:
      return Object.assign({}, state, {
        hash: action.hash,
      });

    case ACTION.FETCH_SHARED_SUCCESS:
      return Object.assign({}, state, {
        error: false,
        sharedHash: action.payload.data.user_id,
        sharedGraves: action.payload.data.graves,
      });

    case ACTION.FETCH_SHARED_FAIL:
      return Object.assign({}, state, {
        error: action.payload,
      });

    case ACTION.SHOW_PATH:
      return {
        ...state,
        currPath: action.path,
        pathToPath: action.pathToPath,
      };

    case ACTION.SELECT_GRAVE:
      return Object.assign({}, state, {
        selectedGrave: action.grave,
      });

    case ACTION.SET_CEMETERY:
      switch (action.cemetery) {
        case 'srebrzysko':
          return {
            ...state,
            ...srebrzyskoCemetery,
          };
        case 'oliwa':
          return {
            ...state,
            ...oliwaCemetery,
          };
        case 'lostowice':
          return {
            ...state,
            ...lostowiceCemetery,
          };
        default:
          return {
            ...state,
            ...srebrzyskoCemetery,
          };
      }

    default:
      return state;
  }
}

export default {
  Data: data,
};



// WEBPACK FOOTER //
// ./src/js/redux/reducers.js